import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20abstract%20background%20with%20flowing%20warm%20coral%20and%20deep%20charcoal%20gradients%2C%20soft%20bokeh%20lights%2C%20elegant%20film%20grain%20texture%2C%20modern%20theater%20ambience%2C%20luxurious%20dark%20warm%20tones%2C%20sophisticated%20entertainment%20atmosphere&width=1800&height=900&seq=hero-bg-01&orientation=landscape"
          alt="番茄视频 - 高清影视在线播放平台"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-white mb-4 leading-tight">
          极致高清 · 流畅观影
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mb-8 leading-relaxed">
          海量电影、电视剧、综艺、动漫高清资源，免费在线观看，不缓冲不卡顿，为您打造随身高清影院
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-4">
          <Link
            to="/category/dianying"
            className="px-8 py-3.5 bg-primary-500 text-white font-semibold rounded-full whitespace-nowrap hover:bg-primary-600 transition-all duration-300 cursor-pointer text-sm"
          >
            <i className="ri-play-fill mr-2"></i>立即观影
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 border-2 border-white/30 text-white font-semibold rounded-full whitespace-nowrap hover:bg-white/10 transition-all duration-300 cursor-pointer text-sm"
          >
            了解更多
          </Link>
        </div>
        <div className="mt-10 flex items-center gap-8">
          {[
            { value: '10万+', label: '影视资源' },
            { value: '5000万+', label: '用户信赖' },
            { value: '4K', label: '超清画质' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-white">{stat.value}</div>
              <div className="text-xs md:text-sm text-white/60 mt-1 whitespace-nowrap">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}